import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Login from "../../LoginContainer";
import HSGFooter from "../../HSGFooterContainer";

import "../../../Themes/Generic.css";
import "./UnAuthenticatedScreen.css";

class UnAuthenticatedScreen extends Component {
  render() {
    return (
      <div>
        {!!!this.props.isAuthenticated && (
          <div>
            <div className="hsg-unauthenticated-container">
              <section>
                <Switch>
                  <Route path="/login" component={Login} />

                  <Redirect to="/login" />
                </Switch>
              </section>
            </div>
            <HSGFooter />
          </div>
        )}
      </div>
    );
  }
}

export default UnAuthenticatedScreen;
